{
  "editDialog": {
    "titleNew": "Новый сотрудник",
    "titleEdit": "Изменить сотрудника — PIN {{pin}}",
    "pinLabel": "ID пользователя устройства (PIN)",
    "nameLabel": "Имя Фамилия",
    "roleLabel": "Роль",
    "cardLabel": "Номер карты",
    "payRates": {
      "legend": "Ставки оплаты (AMD)",
      "hourlyRate": "Почасовая ставка (AMD/ч)",
      "monthlySalary": "Месячный оклад (AMD)",
      "afterHoursRate": "Ставка сверхурочных (AMD/ч)",
      "explainer": "Почасовая ставка применяется при повремённой оплате. Месячный оклад делится пропорционально рабочим дням. Ставка сверхурочных применяется к часам после основного рабочего времени.",
      "unitPerHour": "AMD/ч",
      "unitMonthly": "AMD"
    },
    "workHours": {
      "legend": "Рабочие часы",
      "startLabel": "Начало дня",
      "endLabel": "Конец дня",
      "explainer": "Необязательное индивидуальное время начала и конца рабочего дня. Оставьте пустым, чтобы использовать общий график компании. Изменённое окно действует с сегодняшнего дня, если не указана дата — прошлые дни считаются по прежнему графику.",
      "attendanceExemptLabel": "Присутствует по умолчанию (свободный график)",
      "attendanceExemptHint": "Без вычетов за опоздания, ранний уход, прогулы и без переработок; в табеле рабочие дни отмечаются как присутствие даже без отметок на терминале.",
      "effectiveFromLabel": "Действует с",
      "daysPerWeekLabel": "Рабочих дней в неделю",
      "daysPerWeekCompany": "По графику компании",
      "daysPerWeekHint": "Например 6, если у сотрудника один плавающий выходной в неделю — он будет зачтён автоматически.",
      "restWeekdaysLabel": "Личные выходные дни",
      "restWeekdaysHint": "Постоянные выходные именно этого сотрудника. Отмеченные дни в его табеле идут как X, без вычета, и не входят в делитель оклада. Ничего не выбрано — действует график компании.",
      "days": {
        "mon": "Пн",
        "tue": "Вт",
        "wed": "Ср",
        "thu": "Чт",
        "fri": "Пт",
        "sat": "Сб",
        "sun": "Вс"
      }
    },
    "dates": {
      "legend": "Даты приёма и увольнения",
      "hiredLabel": "Первый рабочий день",
      "registeredLabel": "Дата регистрации в компании",
      "terminatedLabel": "Дата списания (увольнения)",
      "explainer": "Эти даты отображаются в отчёте «Приём на работу»: начало приёма, начало регистрации и окончание."
    },
    "vacation": {
      "legend": "Отпуск",
      "carryoverLabel": "Перенос дней с прошлых лет",
      "explainer": "Неиспользованные дни отпуска до текущего года (например, из старой таблицы Excel). Прибавляются к годовому лимиту в 20 дней в таблице отпусков. Допускаются дробные и отрицательные значения."
    },
    "activeLabel": "Активен",
    "saveFailed": "Не удалось сохранить",
    "pushNotice": "После сохранения на терминал будет отправлена команда.",
    "autoSyncNotice": "Изменения будут автоматически отправлены на терминал.",
    "contact": {
      "legend": "Личные данные и контакты",
      "birthDateLabel": "Дата рождения",
      "phoneLabel": "Телефон",
      "emailLabel": "Email"
    }
  },
  "entriesExits": {
    "title": "Приходы/уходы",
    "exportCsv": "Экспорт CSV",
    "failedToLoad": "Не удалось загрузить данные. Пожалуйста, обновите страницу.",
    "noRecords": "Нет записей за выбранный период",
    "noRecordsHint": "Измените фильтры или дождитесь поступления данных с устройства",
    "filters": {
      "type": "Тип",
      "allTypes": "— все —"
    },
    "eventTypes": {
      "entry": "Приход",
      "exit": "Уход",
      "breakOut": "На перерыв",
      "breakReturn": "С перерыва",
      "overtimeIn": "Начало сверхурочных",
      "overtimeOut": "Конец сверхурочных"
    },
    "verifyModes": {
      "password": "Пароль",
      "fingerprint": "Отпечаток",
      "card": "Карта",
      "passwordFingerprint": "Пароль+Отпечаток",
      "passwordCard": "Пароль+Карта",
      "face": "Лицо",
      "modeN": "Режим {{n}}"
    },
    "columns": {
      "timestamp": "Время",
      "employee": "Сотрудник",
      "type": "Тип",
      "verifyMethod": "Метод верификации"
    },
    "manual": {
      "addButton": "Добавить отметку",
      "title": "Ручная отметка",
      "subtitle": "Если сотрудник забыл отметиться на терминале.",
      "employeeLabel": "Сотрудник",
      "employeePlaceholder": "Выберите сотрудника…",
      "dateLabel": "Дата",
      "timeLabel": "Время",
      "noteLabel": "Примечание (необязательно)",
      "notePlaceholder": "напр. забыл(а) отметить приход",
      "badge": "Ручная",
      "confirmDelete": "Удалить эту отметку сотрудника {{name}}?",
      "errors": {
        "employeeRequired": "Выберите сотрудника.",
        "dateRequired": "Выберите дату.",
        "timeRequired": "Укажите время."
      },
      "toasts": {
        "created": "Отметка добавлена.",
        "createFailed": "Не удалось добавить отметку.",
        "duplicate": "Отметка для этого сотрудника в это время уже существует.",
        "deleted": "Отметка удалена.",
        "deleteFailed": "Не удалось удалить отметку."
      }
    }
  },
  "profile": {
    "back": "Сотрудники",
    "failedToLoad": "Не удалось загрузить сотрудника.",
    "fields": {
      "birthDate": "Дата рождения",
      "phone": "Телефон",
      "email": "Email"
    },
    "documents": {
      "title": "Документы",
      "hint": "Сканы паспорта, договоры и другие файлы. PDF, изображения, Word/Excel — до 15 МБ.",
      "upload": "Загрузить документ",
      "uploading": "Загрузка…",
      "empty": "Документов пока нет.",
      "downloadAria": "Скачать документ",
      "deleteAria": "Удалить документ",
      "toasts": {
        "uploaded": "Документ загружен.",
        "uploadFailed": "Не удалось загрузить документ. Попробуйте ещё раз.",
        "deleted": "Документ удалён.",
        "deleteFailed": "Не удалось удалить документ. Попробуйте ещё раз.",
        "downloadFailed": "Не удалось скачать документ. Попробуйте ещё раз."
      }
    },
    "details": {
      "title": "Подробности",
      "work": "Работа и даты",
      "workHours": "Рабочие часы",
      "companySchedule": "График компании",
      "terminals": "Терминалы и биометрия",
      "devices": "Терминалы",
      "biometrics": "Биометрия",
      "pay": "Оплата",
      "hourlyRate": "Часовая ставка",
      "monthlySalary": "Месячный оклад",
      "overtimeRate": "Ставка сверхурочных",
      "carryover": "Перенос отпуска",
      "daysUnit": "дн.",
      "biometricKinds": {
        "face": "Лицо",
        "fp": "Отпечаток",
        "palm": "Ладонь"
      }
    },
    "photo": {
      "changeAria": "Изменить фото",
      "removeAria": "Удалить фото",
      "hint": "JPEG, PNG или WebP — до 10 МБ.",
      "toasts": {
        "uploaded": "Фото обновлено.",
        "uploadFailed": "Не удалось загрузить фото. Попробуйте ещё раз.",
        "removed": "Фото удалено.",
        "removeFailed": "Не удалось удалить фото. Попробуйте ещё раз."
      }
    }
  }
}
